import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';
import { AlignCenter, HideScrollbar, LineClamp } from '../../../../../global/commonStyle';

interface Props {
  isActive?: boolean;
}

export const LeftSection = styled.div`
  min-width: 400px;
  max-width: 400px;
  padding: var(--space-20) var(--space-20) var(--space-32);
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  height: calc(100dvh - 130px);
  ${mobile_xl(css`
    min-width: unset;
    width: calc(100vw - 40px);
    padding-block: var(--space-2) var(--space-96);
    gap: var(--space-16);
    height: unset;
  `)};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${HideScrollbar}
  ${mobile_xl(css`
    overflow: unset;
  `)}
`;

export const MainTemplateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;

export const TemplateHeading = styled.p`
  padding-inline: var(--space-12);
  margin: var(--space-0);
  width: max-content;
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  ${mobile_xl(css`
    padding-inline: var(--space-0);
  `)}
`;

export const TemplateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  ${mobile_xl(css`
    gap: var(--space-3);
  `)}
`;

export const TemplateListItem = styled.div<Props>`
  padding: var(--space-8) var(--space-12);
  ${AlignCenter}
  gap: var(--space-12);
  border-radius: var(--border-radius-12);
  background-color: ${({ isActive }) => (isActive ? 'var(--background-muted)' : 'transparent')};
  cursor: pointer;
  &:hover {
    background-color: ${({ isActive }) => (isActive ? 'var(--background-muted)' : ' var(--neutral-secondary)')};
  }
  ${mobile_xl(css`
    background-color: transparent;
    padding-inline: var(--space-0);
    &:hover {
      background-color: transparent;
    }
  `)}
`;

export const ProjectIcon = styled.div`
  padding-block: var(--space-3);
  ${mobile_xl(css`
    padding-block: var(--space-5);
  `)}
`;

export const TemplateDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;
export const TemplateTitle = styled.p`
  margin: var(--space-0);
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  ${LineClamp(1)}
  word-break: break-all;
  white-space: normal;
`;

export const TemplateDescription = styled.p`
  margin: var(--space-0);
  ${Typography.body_md}
  color: var(--text-secondary);
  ${LineClamp(1)}
  word-break: break-all;
  white-space: normal;
`;
